import { render } from "./Confetti.vue?vue&type=template&id=b9525caa"
const script = {}

import "./Confetti.vue?vue&type=style&index=0&id=b9525caa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__